(function () {
  function getFormById(id) {
    if (!id) return null;
    try {
      return document.getElementById(id) || document.querySelector(`form[id="${CSS.escape(id)}"]`);
    } catch (e) {
      return document.getElementById(id) || document.querySelector(`form[id="${id}"]`);
    }
  }

  function getVariantId(formEl) {
    const idInput = formEl?.querySelector('input[name="id"]');
    return idInput?.value || null;
  }

  function getQty(formEl) {
    const qtyInput = formEl?.querySelector('input[name="quantity"]');
    const v = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(v) && v > 0 ? v : 1;
  }

  function loadQuote() {
    try {
      return JSON.parse(localStorage.getItem('stola_quote_v1')) || [];
    } catch (e) {
      return [];
    }
  }

  function updateHeaderQuoteCount(items) {
    try {
      const quote = items || loadQuote();
      const quoteCountEl = document.getElementById('header-quote-count');

      if (!quoteCountEl) return;

      const totalQty = quote.reduce((sum, item) => {
        return sum + (parseInt(item.qty, 10) || 0);
      }, 0);

      if (totalQty > 0) {
        quoteCountEl.textContent = totalQty;
        quoteCountEl.classList.remove('opacity-0');
      } else {
        quoteCountEl.textContent = '0';
        quoteCountEl.classList.add('opacity-0');
      }
    } catch (e) {
      console.warn('Quote count kon niet direct geüpdatet worden', e);
    }
  }

  function saveQuote(items) {
    localStorage.setItem('stola_quote_v1', JSON.stringify(items));
    updateHeaderQuoteCount(items);
  }

  function upsert(items, item) {
    const idx = items.findIndex(i => String(i.variant_id) === String(item.variant_id));

    if (idx >= 0) {
      items[idx].qty = (parseInt(items[idx].qty, 10) || 0) + (parseInt(item.qty, 10) || 1);
      items[idx].updated_at = new Date().toISOString();
      return items;
    }

    items.push(item);
    return items;
  }

  function setBtnState(btn, text) {
    const label = btn.querySelector('span');
    if (!label) return;

    const original = btn.getAttribute('data-original-label') || label.textContent.trim();

    if (!btn.getAttribute('data-original-label')) {
      btn.setAttribute('data-original-label', original);
    }

    label.textContent = text;
    btn.disabled = true;

    window.clearTimeout(btn._stolaTimer);
    btn._stolaTimer = window.setTimeout(() => {
      label.textContent = original;
      btn.disabled = false;
    }, 1400);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-stola-quote-add]');
    if (!btn) return;

    const formId = btn.getAttribute('data-form-id');
    const formEl = getFormById(formId) || btn.closest('form');

    const variantId = getVariantId(formEl);
    if (!variantId) {
      setBtnState(btn, 'Kies variant');
      return;
    }

    const item = {
      variant_id: variantId,
      qty: getQty(formEl),
      product_handle: btn.getAttribute('data-product-handle') || '',
      product_title: btn.getAttribute('data-product-title') || '',
      added_at: new Date().toISOString()
    };

    const quote = loadQuote();
    saveQuote(upsert(quote, item));

    setBtnState(btn, 'Toegevoegd ✓');
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderQuoteCount();
  });

  window.StolaQuote = {
    load: loadQuote,
    save: saveQuote,
    clear: function () {
      saveQuote([]);
    },
    updateHeaderCount: updateHeaderQuoteCount
  };
})();